<template>
  <div class="header">
    <div class="row">
      <div class="col-12 col-md-5">
        <div class="text-header">
          <!-- <span>юридическое лицо</span> -->
          <p class="h1-text">{{ partnerDisplay  }}</p>
        </div>
      </div>
      <div class="col-12 col-md-7">
        <div class="block-filter">
          <!-- Сквозной поиск по b2b порталу по номерам заказов, претензий, 
            обращений и коммерческих предложений. Отображение на каждой странице портала -->
          <div class="header-search-block">
            <input 
              type="text" 
              placeholder="Поиск по номеру документа"
              @keyup.enter="performSearch" 
              v-model="searchQuery" 
            >
            <mdicon name="magnify" width="17px"/>
          </div>
          <!-- При клике на кнопку должно открываться окно с фильтром по полям заказа.  -->
          <button
            id="filter-btn"
            v-show="filter"
            class="btn btn-default ml-25"
            @click="filterClick"
          >
            <mdicon name="filter" width="17px"/> 
            <span>Фильтр</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="text-header second-header-block">
          <h1>
            <span v-if="numberOrder != ''">{{ currentRoute.meta.title }} № {{ this.numberOrder }}</span>
            <span v-else-if="currentRoute.name == 'order/search'"> "{{ currentRoute.query.q }}"</span>
            <span v-else>{{ currentRoute.meta.title }}</span>
          </h1>
        </div>
      </div>
      <div v-show="createBtn" class="col-12 col-md-6">
        <div class="block-filter">
          <button
            class="btn btn-success"
            :disabled="createBtnDisable"
            @click="createClick"
          > 
            <span>{{ createBtnText }}</span>
          </button>
        </div>
      </div>
      <div v-show="fileBtn" class="col-12 col-md-6">
        <div class="block-filter">
          <button
            class="btn btn-success"
            @click="downloadFile"
          > 
            <span>{{ fileBtn }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
  export default {
    name: 'TopNavbar',

    emits: [
      'openModalFilter',
      'createElement',
      'downloadFile'
    ],

    props: {
      currentRoute: {
        type: Object,
        default: () => ({})
      },
      filter: {
        type: Boolean,
        default: false
      },
      createBtn: {
        type: Boolean,
        default: false
      },
      createBtnText: {
        type: String,
        default: "Создать"
      },
      createBtnDisable: {
        type: Boolean,
        default: false
      },
      numberOrder:  {
        type: [Number, String],
        default: ""
      },
      fileBtn: {
        type: String,
        default: ""
      },
    },
    computed: {
      partnerDisplay() {
        const raw = localStorage.getItem('partner') || '';
        try { 
          return JSON.parse(raw); 
        } catch (_) {
          // если обычная строка, то на всякий случай уберём экранирование
          return raw.replace(/\\"/g, '"').replace(/^"(.*)"$/, '$1');
        }
      }
    },
    data() {
      return {
        partner: "",
        searchQuery: ""
      }
    },
    mounted() {
      if(localStorage.getItem('token') == undefined || localStorage.getItem('token') == '') {
        this.$router.push({
          path: '/login'
        });
      }
    },
    methods: {
      filterClick() {
        this.$emit('openModalFilter', true)
      },

      createClick() {
        this.$emit('createElement', true)
      },

      getInfo() {
        if(localStorage.getItem('partner') != undefined && localStorage.getItem('partner') != '') {
          this.partner = localStorage.getItem('partner')
        }
        return this.partner
      },

      performSearch() {
        if (this.searchQuery.trim() !== '') {
          const currentRoute = this.$router.currentRoute.value;

          // Условие для проверки, если текущий путь - /order/search
          if (currentRoute.path === '/order/search') {
            // Обновление строки запроса
            this.$router.replace({
              path: currentRoute.path,
              query: { 
                q: this.searchQuery.trim() 
              },
            });
            
            setTimeout(() => {
              window.location.reload();
            }, 100); // 100 мс задержка
          } else {
            // Переход на нужный путь
            this.$router.push({
              path: '/order/search',
              query: { 
                q: this.searchQuery.trim() 
              },
            });
          }

        }
      },

      downloadFile() {
        this.$emit('downloadFile', true)
      },

    }
  };
  </script>